import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePlan } from '../../contexts/PlanContext';
import LockedFeaturePage from '../Common/LockedFeaturePage';

/**
 * PlanGate — wraps a route element and shows LockedFeaturePage if the
 * plan feature is disabled. If the feature is hidden at platform level,
 * redirects away entirely.
 *
 * Usage: <PlanGate feature="quizAssessment"><QuizCategoriesPage /></PlanGate>
 *        <PlanGate feature="quizAssessment" label="Quiz & Assessments"><Component /></PlanGate>
 */
const PlanGate = ({ feature, label, children }) => {
  const { hasPlanFeature, isFeatureHidden, loading } = usePlan();

  // While loading plan data, render children optimistically (fail open)
  if (loading) return children;

  // Platform-level kill switch — redirect, don't even show locked page
  if (isFeatureHidden(feature)) {
    return <Navigate to="/" replace />;
  }

  if (!hasPlanFeature(feature)) {
    return <LockedFeaturePage featureKey={feature} featureLabel={label} />;
  }

  return children;
};

export default PlanGate;
